import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {CesiumAdapterService} from "../../services/cesiumAdapter21/cesium-adapter.service";
import {debounceTime} from "rxjs/operators";
import {AbstractObserver} from "../../classes/AbstractObserver/AbstractObserver";
declare var Yiit;

@Component({
  selector: 'app-zoom-controls',
  templateUrl: './zoom-controls.component.html',
  styleUrls: ['./zoom-controls.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ZoomControlsComponent extends AbstractObserver implements OnInit {

  public Yiit = Yiit;
  private viewer;
  public isThreeDModeEnabled:boolean;

  constructor(protected adapter: CesiumAdapterService, protected cd: ChangeDetectorRef) {
    super();
  }

  ngOnInit() {
    this.viewer = this.adapter.viewer;
    this.subscribeToObservable(this.adapter.isThreeDMode, ((flag:boolean)=>{
      this.isThreeDModeEnabled = flag;
      this.cd.detectChanges();
    }));

    this.subscribeToObservable(this.adapter.zoom.pipe(debounceTime(500)), (()=>{
      this.cd.detectChanges();
    }));
  }

  zoomIn($event?: any){
    if ($event) {
      $event.preventDefault();
    }
    this.adapter.zoomIn($event ? $event.ctrlKey : false);
    this.cd.detectChanges();
  }

  zoomOut($event?: any){
    if ($event) {
      $event.preventDefault();
    }
    this.adapter.zoomOut($event ? $event.ctrlKey : false);
    this.cd.detectChanges();
  }

  rotateCameraTo(direction:string){
    this.adapter.rotateCamera(direction);
    this.cd.detectChanges();
  }

}
